import { SortDirectionEnum } from '../../enums';

export interface BaseSearchQueryInterface{
  pageNumber: number;
  pageSize: number;
  sortCol: string;
  sortDir: SortDirectionEnum;
}
